module.exports = __webpack_public_path__ + "img/kiryu.785883aa.png";